import { useSoftDeployAccess } from 'App/components/hooks';

export default function TaskListAllowed() {
	return useSoftDeployAccess('TODO_LIST');
}
